<template>
  <div class="information">
    <div class="information__desc">
      <AppDescriptionItem
        v-for="(item, index) of description"
        :key="index"
        :icon="item.icon"
        :label="item.label"
        :value="item.value"
        :valueHref="item.valueHref"
      />
    </div>

    <div class="comment">
      <p class="comment__title">Комментарий создателя</p>
      <div class="comment__block">
        {{ eventDesc.comment }}
      </div>
    </div>

    <BaseButton
      theme="simple"
      class="information__btn-delete"
      @click="onDelete"
    >
      Удалить
    </BaseButton>
  </div>
</template>

<script>
import AppDescriptionItem from '@/components/AppDescriptionItem'
import BaseButton from '@/components/Base/BaseButton'
export default {
  name: 'AppInformation',
  components: {
    BaseButton,
    AppDescriptionItem
  },
  data () {
    return {
      eventDesc: {
        place: '',
        placeId: '',
        address: '',
        start: '',
        level: '',
        progress: '',
        comment: ''
      }
    }
  },
  computed: {
    description () {
      return [
        {
          icon: 'coating',
          label: 'Место',
          value: this.eventDesc.place,
          valueHref: this.eventDesc.placeId
        },
        {
          icon: 'pin',
          label: 'Адрес',
          value: this.eventDesc.address
        },
        {
          icon: 'clock',
          label: 'Начало события',
          value: this.eventDesc.start
        },
        {
          icon: 'level',
          label: 'Уровень игры',
          value: this.eventDesc.level
        },
        {
          icon: 'list',
          label: 'Количество игроков',
          value: this.eventDesc.progress
        }
      ]
    }
  },
  async created () {
    await this.fetchEventData()
  },
  methods: {
    async fetchEventData () {
      const id = this.$route.params.id

      try {
        const { data } = await this.$api.events.event(id)

        this.eventDesc.place = data?.playgroundTitle ?? ''
        this.eventDesc.placeId = '/fields/' + data?.playgroundId ?? ''
        this.eventDesc.address = data?.address ?? ''
        this.eventDesc.start = data?.start ?? ''
        this.eventDesc.level = data?.gameLevel ?? ''
        this.eventDesc.progress = data?.players ?? ''
        this.eventDesc.comment = data?.comment ?? ''
      } catch (e) {
        console.log(e)
      }
    },
    async onDelete () {
      if (!confirm('Вы уверены?')) { return }
      const id = this.$route.params.id

      try {
        await this.$api.events.delete(id)
        this.$router.push('/events')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  &__desc {
    max-width: 900px;
  }

  &__btn-delete {
    padding: 0;
    color: red;
    margin-top: 20px;
  }

  .comment {
    margin-top: 50px;

    &__title {
      font-weight: bold;
      font-size: 18px;
    }
    &__block {
      margin-top: 12px;
      background: #1D1D1D;
      border-radius: 12px;
      min-height: 175px;
      max-width: 520px;
      padding: 16px;
      font-size: 16px;
      color: #A1A1A8;
    }
  }
}
</style>
